<nav *ngIf="pageData">
    <div class="links">
            <a *ngFor="let menuItem of pageData" [href]="menuItem.url" [ngClass]="{ 'active' : menuItem.isSelectable, 'isvisible': menuItem.isVisible }"
                (click)="activeLink(menuItem.name);closeMobileMenu()">{{ menuItem.name }}</a>
    </div>
</nav>

